import templateStr from 'text!./cpp-location-header.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            isPrimary: '&',
            displayName: '&',
            numBuildings: '&',
            isAccordionOpen: '=',
            primaryMarkNextLine: '&',
            showBuilding: '&',
            showActions: '&',
            showCarrot: '&',
            wide: '&',
            locationId: '&',
            onRemove: '&',
            onEdit: '&'
        },
        controller: function controller($scope) {
            $scope.hasNumBuildingsInfo = function () {
                return typeof $scope.numBuildings() === 'number';
            };

            $scope.removeLocation = function () {
                if (typeof $scope.onRemove() === 'function') {
                    $scope.onRemove()();
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/locationsAndBuildings/directives/cpp-location-directive/CPPLocationHeader.js
// module id = 818
// module chunks = 0